<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="normal"
      @cancel="cancel"
      @confirm="confirm"
      :confirm-loading="confirmLoading"
  >
    <template #header>仓库盘点</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="140px"
      >
        <el-form-item
            label="盘点仓"
            prop="warehouseId"
            :rules="[
              $gjRequired('请选择仓库')
            ]"
        >
          <gj-warehouse-select
              :fba="false"
              v-model="form.warehouseId"
              :noValid="true"
              width="240px"
          ></gj-warehouse-select>
        </el-form-item>
        <el-form-item
            label="不参与盘点数据"
        >
          <div><gj-checkbox v-model="form.excludeInactiveSku">停用状态的产品数据</gj-checkbox></div>
          <div><gj-checkbox v-model="form.excludeZeroInventory">在库量为0的产品数据</gj-checkbox></div>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, responseMixin} from "../../../../../minxins";
  import {warehouseCheck} from "../../../../../api/warehouse";

  export default {
    name: "app-warehouse-counting",
    mixins: [modalMixIn, formRuleMixin, responseMixin],
    data() {
      return {
        form: {
          warehouseId: null,
          excludeInactiveSku: false,
          excludeZeroInventory: false
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          warehouseCheck(this.form)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('after');
                this.$gjDestroy();
              })
            }).complete(() => this.confirmLoading = false)
        }
      }
    }
  }
</script>

<style scoped>

</style>
